// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import { makeServiceRequest } from '../ServiceRequest';
import type RequestOptions from '../RequestOptions';
import type DeleteBookingServiceJsonRequest from '../contract/DeleteBookingServiceJsonRequest';
import type DeleteBookingServiceJsonResponse from '../contract/DeleteBookingServiceJsonResponse';
import deleteBookingServiceJsonRequest from '../factory/deleteBookingServiceJsonRequest';

export default function deleteBookingServiceOperation(
    req: DeleteBookingServiceJsonRequest,
    options?: RequestOptions
): Promise<DeleteBookingServiceJsonResponse> {
    if (req !== undefined && !req['__type']) {
        req = deleteBookingServiceJsonRequest(req);
    }

    return makeServiceRequest<DeleteBookingServiceJsonResponse>(
        'DeleteBookingService',
        req,
        options
    );
}
